import { render } from "./location-panarams.vue?vue&type=template&id=48e70b36"
import script from "./location-panarams.vue?vue&type=script&lang=js"
export * from "./location-panarams.vue?vue&type=script&lang=js"

import "./location-panarams.vue?vue&type=style&index=0&id=48e70b36&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__